import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant" }
const _hoisted_6 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_7 = { colspan: "12" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "fw-bold text-warning-emphasis d-flex" }

import { ref, onMounted } from "vue";
import DocsServices from "../services/DocsServices";
import { useStore } from "@/store";
import EditContract from "../components/ContractSpecs/EditContract.vue";
import { ElNotification } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Memo } from "@element-plus/icons-vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ContractSpecsIndex',
  setup(__props) {

const store = useStore();
const user = store.state.AuthModule.user;
const EditContractRef = ref<any>(null);
const site = ref(user.tenancy == "au" ? "ba" : user.tenancy);
const isLoading = ref(false);
const statusSwitchLoading = ref(false);
const data = ref<any>([]);
const categories = ref<any>([]);
const criteria = ref<any>({
  page: 1,
  size: 25,
  site: site.value,
});
const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await DocsServices.queryContractSpecsList(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
    categories.value = res.categories;
  } catch (error) {
    console.error(error);
    MsgPrompt.error("Fetch data failed");
  }
  isLoading.value = false;
};

const switchStatus = async (item: any) => {
  statusSwitchLoading.value = true;
  try {
    await DocsServices.updateContractSpecsStatus(item.id);
    ElNotification({
      title: "Success",
      message: "Update status successfully",
      type: "success",
    });
  } catch (error) {
    console.error(error);
    ElNotification({
      title: "Error",
      message: "Update status failed",
      type: "error",
    });
  }
  statusSwitchLoading.value = false;
};

const showEdit = (item: any) => {
  EditContractRef.value?.show(item);
};

const reset = async () => {
  criteria.value = {
    page: 1,
    size: 25,
    site: site.value,
  };
  await fetchData(1);
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_select, {
            modelValue: criteria.value.category,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.category) = $event)),
            placeholder: _ctx.$t('fields.category'),
            disabled: isLoading.value || statusSwitchLoading.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "disabled"]),
          _createVNode(_component_el_input, {
            modelValue: criteria.value.symbol,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.symbol) = $event)),
            placeholder: _ctx.$t('fields.symbol'),
            disabled: isLoading.value || statusSwitchLoading.value,
            class: "ms-4",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue", "placeholder", "disabled"]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (fetchData(1))),
            loading: isLoading.value,
            disabled: statusSwitchLoading.value,
            class: "ms-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]),
          _createVNode(_component_el_button, {
            onClick: reset,
            disabled: isLoading.value || statusSwitchLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.symbol")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.category")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.contractSize")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.tradeTime")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.weekDay")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.breakTime")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.breakTime")) + " - 2", 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.commission")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.marginRequirement")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.uploadedBy")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(ScaleLoader, { color: '#ffc730' })
                  ])
                ])
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_switch, {
                          modelValue: item.is_enabled,
                          "onUpdate:modelValue": ($event: any) => ((item.is_enabled) = $event),
                          style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"},
                          "active-value": 1,
                          "inactive-value": 0,
                          loading: statusSwitchLoading.value,
                          onChange: ($event: any) => (switchStatus(item))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "loading", "onChange"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.symbol), 1),
                      _createElementVNode("td", null, _toDisplayString(item.category), 1),
                      _createElementVNode("td", null, _toDisplayString(item.contract_size), 1),
                      _createElementVNode("td", null, _toDisplayString(item.trading_start_time) + " - " + _toDisplayString(item.trading_end_time), 1),
                      _createElementVNode("td", null, _toDisplayString(item.trading_start_weekday) + " - " + _toDisplayString(item.trading_end_weekday), 1),
                      _createElementVNode("td", null, _toDisplayString(item.break_start_time) + " - " + _toDisplayString(item.break_end_time), 1),
                      _createElementVNode("td", null, [
                        (item.more_break_start_time)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.more_break_start_time) + " - " + _toDisplayString(item.more_break_end_time), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.commission), 1),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.margin_requirements, (margin, index) => {
                          return (_openBlock(), _createBlock(_component_el_tag, {
                            key: index,
                            class: "me-1",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              (site.value == 'ba')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(index) + ": " + _toDisplayString(margin), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(margin), 1))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, [
                        (item.operator_info)
                          ? (_openBlock(), _createBlock(_component_el_popover, {
                              key: 0,
                              width: 300
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  icon: _unref(Memo),
                                  size: "small",
                                  circle: ""
                                }, null, 8, ["icon"])
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.operator_info, (operator, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                                    _createElementVNode("p", _hoisted_13, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("fields.updated_at")) + " : ", 1),
                                      _createVNode(_component_TimeShow, {
                                        type: "GMToneLiner",
                                        "date-iso-string": operator.updatedAt
                                      }, null, 8, ["date-iso-string"])
                                    ]),
                                    _createElementVNode("p", null, _toDisplayString(operator.name) + " - " + _toDisplayString(operator.email), 1),
                                    _createVNode(_component_el_divider)
                                  ]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: ($event: any) => (showEdit(item)),
                          disabled: statusSwitchLoading.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(EditContract, {
      ref_key: "EditContractRef",
      ref: EditContractRef,
      onEventSubmit: _cache[4] || (_cache[4] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ], 64))
}
}

})